<template>
  <NuxtLoadingIndicator />
  <div v-scroll-lock="isMenuOpen" :class="{ isLocked: isMenuOpen }">
    <NuxtLayout :name="layout">
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<script setup>
import { vScrollLock } from '@vueuse/components';
import { useGlobalStore } from '~/stores/global';
import {
  addRobotsPages,
  cachedPageMeta,
  pagesWithoutSeoData,
} from '~/common/const';
import 'swiper/scss';
import 'swiper/scss/pagination';
import 'swiper/scss/navigation';

const globalStore = useGlobalStore();
const route = useRoute();
const router = useRouter();
const url = useRequestURL();

const getSeoHead = (newRoute) => {
  try {
    const name = newRoute?.name || route?.name;
    const page = pagesWithoutSeoData.find((pageName) => pageName === name);
    if (page && page in cachedPageMeta) {
      return cachedPageMeta[page];
    }
    return {
      title:
        globalStore.seoData?.page?.title ||
        'Цены, скидки, товары, все интернет-магазины на Price.ru',
      description:
        globalStore.seoData?.page?.description ||
        'Цены, скидки, товары, все интернет-магазины на Price.ru',
    };
  } catch {
    return {
      title: 'Цены, скидки, товары, все интернет-магазины на Price.ru',
      description: 'Цены, скидки, товары, все интернет-магазины на Price.ru',
    };
  }
};
const title = ref(getSeoHead().title);
const description = ref(getSeoHead().description);

const layout = computed(() => {
  if (route?.path.includes('/uikit/')) {
    return 'uikit';
  }
  if (route?.path.includes('/price-clear/?price=3')) {
    return 'debug-clear';
  }
  return 'default';
});

const isMenuOpen = computed(() => globalStore.isMenuOpen);

const isOnlyEridCampaign = (queryNameArr) => {
  // проверка что есть utm_campaign и erid и только они
  const { count, inclusive, exclusive } = queryNameArr.reduce(
    (acc, item) => {
      if (['erid', 'utm_campaign'].includes(item)) {
        acc.inclusive = true;
        acc.count++;
      } else {
        acc.exclusive = true;
      }
      return acc;
    },
    { inclusive: false, exclusive: false, count: 0 }
  );
  return inclusive && count === 2 && !exclusive;
};

const getRobotsValue = () => {
  try {
    if (addRobotsPages.includes(globalStore.seoData?.page?.component)) {
      if (
        route.query?.page ||
        route.query?.['type-display'] ||
        route.query?.['products-sort']
      ) {
        return false;
      }
    }
    const queryNameArr = Object.keys(route.query || {});

    if (isOnlyEridCampaign(queryNameArr)) {
      return false;
    }

    const exclusionQuery = [
      'utm_content',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'goto',
    ];
    const isExclusion = queryNameArr.reduce((is, item) => {
      if (exclusionQuery.includes(item)) is = true;
      return is;
    }, false);
    const isNoExclusion = queryNameArr.reduce((is, item) => {
      if (!exclusionQuery.includes(item)) is = true;
      return is;
    }, false);

    // если пришли с метками из виджета без лишнего, noindex не добавляем
    if (isExclusion && !isNoExclusion) return false;

    // добавляем noindex если были любые query параметры
    return isNoExclusion;
  } catch {
    return true;
  }
};

const listWithBrand =
  addRobotsPages.includes(globalStore.seoData?.page?.component) &&
  route.query?.brand_id;

router.beforeEach((to, _) => {
  title.value = getSeoHead(to).title;
  description.value = getSeoHead(to).description;
});

useHead(() => {
  let head = {};
  const meta = [];
  try {
    const page = pagesWithoutSeoData.find(
      (pageName) => pageName === route?.name
    );
    if (page) {
      head = cachedPageMeta[page] || {};
      title.value = head.title;
      description.value = head.description;
    } else {
      const keywords =
        globalStore.seoData?.page?.keywords ||
        'Цены, скидки, товары, все интернет-магазины на Price.ru';
      const is_active = globalStore.seoData?.page?.is_active || false;
      if (is_active === false || getRobotsValue()) {
        meta.push({
          hid: 'robots',
          name: listWithBrand ? 'googlebot' : 'robots',
          content: 'noindex, nofollow',
        });
      }
      head = {
        title,
        keywords,
        is_active: Boolean(is_active),
        meta,
      };
    }
  } catch {
    head = {
      title: 'Ошибка',
      description: 'Ошибка',
      keywords: '',
      is_active: false,
    };
  }
  return {
    ...head,
    link: [
      {
        rel: 'canonical',
        href: url?.origin && route.path ? url.origin + route.path : '',
      },
    ],
  };
});
useSeoMeta({
  title,
  ogTitle: title,
  description,
  ogDescription: description,
});
</script>
<style lang="scss">
.isLocked {
  height: 100vh;
}

html,
body {
  padding: 0;
}
</style>
<!--<style lang="scss" src="./assets/style/_reset.scss"></style>-->
<!--<style lang="scss" src="./assets/style/fonts.scss"></style>-->
<!--<style lang="scss" src="./assets/style/init.scss"></style>-->
<!--<style lang="scss" src="./assets/style/global.scss"></style>-->
